import styled from 'styled-components'

import { Spacer } from './spacer'

export const StyledSettingsSpacer = styled(Spacer)`
  background-color: ${(props) => props.theme.background};
`
